import { useDarkModeCheck } from "@/contexts/RADashboardThemeContext/hooks"
import { LayoutEditorProps, RADashboardLayout } from "@/interfaces/raDashboard.interface"
import ReactJsonView, { InteractionProps } from '@microlink/react-json-view'
import { Box } from "@mui/material"
import React from "react"
import DashboardKeyStringsInfo from "./DashboardKeyStringsInfo"

const DashboardJsonEditor: React.FC<LayoutEditorProps> = (props) => {
  const isDarkMode = useDarkModeCheck();

  const tryUpdateDashboard = (args: InteractionProps) => {
    props.setLayout(args.updated_src as RADashboardLayout)
    return true;
  }

  return (
    <div style={{display: 'flex', marginTop: 24}}>
      <Box sx={{flex: 4}}>
        <ReactJsonView src={props.layout ?? {}} name={false} validationMessage="Operation failed. Was not a valid dashboard"
          theme={isDarkMode ? "monokai" : "rjv-default"} collapsed={false}
          displayDataTypes={false} displayObjectSize={false} displayArrayKey={false} enableClipboard={false}
          onEdit={props.isLocked ? undefined : tryUpdateDashboard}
          onAdd={props.isLocked ? undefined : tryUpdateDashboard}
          onDelete={props.isLocked ? undefined : tryUpdateDashboard}/>
      </Box>
      <DashboardKeyStringsInfo dashboardType={props.dashboardType} />
    </div>
  );
}

export default DashboardJsonEditor
